import { Typography, ButtonBase } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { Box } from "@mui/system"
import { GroupBy } from "../../meetingServiceTypes"
import { useAppLocalization } from "../../../../../../localization/components/AppLocalizationProvider"
import HeaderFilter from "./HeaderFilter"

interface Props {
    groupBy: GroupBy
    setGroupBy: (value: GroupBy) => void
}

const useStyles = makeStyles()((theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        gap: "0.75rem",
    },
    label: {
        color: theme.palette.tailwind.slate[600],
    },
    buttonsRow: {
        display: "flex",
        flexDirection: "row",
        gap: "0.5rem",
        backgroundColor: theme.palette.tailwind.slate[100],
        borderRadius: "5.625rem",
        padding: "0.25rem",
    },
    pillButton: {
        padding: "0 0.75rem",
        borderRadius: "5.625rem",
        border: "none",
        backgroundColor: "transparent",
        color: theme.palette.text.secondary,
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: "1.5rem",
        cursor: "pointer",
        transition: "all 0.2s ease",
        // "&:hover": {
        //     backgroundColor: "transparent",
        // },
    },
    pillButtonSelected: {
        backgroundColor: "black",
        color: "white",
        fontWeight: 500,
        // "&:hover": {
        //     backgroundColor: theme.palette.tailwind.slate[300],
        // },
    },
}))

export default function GroupBySwitch({ groupBy, setGroupBy }: Props) {
    const { classes, cx } = useStyles()
    const { l10n } = useAppLocalization()

    return (
        <HeaderFilter label={l10n.getString("meeting-service-delivery-list-group-by-label")}>
            <Box className={classes.buttonsRow}>
                <LocalizedStrict id="meeting-service-delivery-list-group-by-location">
                    <ButtonBase
                        onClick={() => setGroupBy("location")}
                        className={cx(classes.pillButton, {
                            [classes.pillButtonSelected]: groupBy === "location",
                        })}
                    >
                        delivery location
                    </ButtonBase>
                </LocalizedStrict>

                <LocalizedStrict id="meeting-service-delivery-list-group-by-time">
                    <ButtonBase
                        onClick={() => setGroupBy("time")}
                        className={cx(classes.pillButton, {
                            [classes.pillButtonSelected]: groupBy === "time",
                        })}
                    >
                        delivery time
                    </ButtonBase>
                </LocalizedStrict>
            </Box>
        </HeaderFilter>
    )
}
